import { Icon } from "@chakra-ui/react"
import { BIG_ZERO, Position } from "@perp/sdk-curie"
import Big from "big.js"
import { Stats } from "component/Stats"
import { RiHandCoinLine } from "react-icons/ri"

import { usePositionWithRatioStrings } from "../../../position/hook/usePositionWithRatioStrings"

interface Props {
    position: Position
    fees: string // required to calculate net return
    ratio?: number
}

export function MakerPositionNetReturn({ position, ratio, fees }: Props) {
    const { unrealizedPnl } = usePositionWithRatioStrings(position, ratio)

    const gain = fees ? new Big(fees) : BIG_ZERO
    const loss = unrealizedPnl ? new Big(unrealizedPnl) : BIG_ZERO
    const netReturnStr = unrealizedPnl ? `${gain.plus(loss).toFixed(1)}` : "0"

    return (
        <Stats
            icon={<Icon color="purple.400" as={RiHandCoinLine} />}
            showTooltip={true}
            size="xl"
            label="Net Return"
            number={
                netReturnStr.startsWith("-") ? "-$" + new Big(netReturnStr).toFixed(1).substring(1) : `$${netReturnStr}`
            }
            helper="Total Fees - Impermanent Loss"
        />
    )
}
